import React from 'react';
import { Checkbox } from 'baseui/checkbox';
import type { AnnotationInfoT } from '../annotations/types';
type PropsT = {
  annotation: AnnotationInfoT;
  isChecked: boolean;
  onCheck: (id: string) => void;
};
export function SelectAnnotationCheckbox({
  annotation,
  isChecked,
  onCheck
}: PropsT) {
  const {
    id,
    isDisabled
  } = annotation;
  return <Checkbox disabled={isDisabled} checked={isChecked || isDisabled} aria-label="Select Annotation" onChange={e => {
    e.stopPropagation();
    onCheck(id);
  }} />;
}